import { CartProduct } from "../types/cart.types";

export const SHIPPING_FEE = 100;

export const PAYMENT_MODE = {
  /** Cash on delivery — registered accounts only, and only when the Bag API's enable_mode allows it. */
  CASH: 1,
  ONLINE: 2,
} as const;

export interface CartTotals {
  totalMRP: number;
  totalDiscount: number;
  shippingFee: number;
  totalAmount: number;
  hasOutOfStock: boolean;
}

/** Computes MRP, discount, shipping and payable totals for the selected cart items. */
export const calculateCartTotals = (items: CartProduct[]): CartTotals => {
  const totalMRP = items.reduce(
    (sum, i) => sum + (Number(i.mrp) || 0) * (Number(i.quantity) || 0),
    0,
  );
  const totalDiscount = items.reduce(
    (sum, i) =>
      sum + ((Number(i.mrp) || 0) - (Number(i.price) || 0)) * (Number(i.quantity) || 0),
    0,
  );
  const totalAmount = totalMRP - totalDiscount + SHIPPING_FEE;
  const hasOutOfStock = items.some((p) => p.isStockOut);

  return {
    totalMRP,
    totalDiscount,
    shippingFee: SHIPPING_FEE,
    totalAmount,
    hasOutOfStock,
  };
};
